/*
 * Copyright 2023 Neckar IT GmbH, Mössingen, Germany
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package com.meistercharts.js

import com.meistercharts.js.external.FontFace
import com.meistercharts.js.external.FontFaceSet
import com.meistercharts.js.external.listenForLoadingDone
import kotlinx.browser.document
import org.w3c.dom.get

internal actual fun listenForFontLoadingDone(onLoadingDone: (loadedFonts: () -> List<String>) -> Unit): Boolean {
  val fontFaceSet = document["fonts"]?.unsafeCast<FontFaceSet>() ?: return false
  fontFaceSet.listenForLoadingDone { event ->
    onLoadingDone { event.fontfaces.map { it.format() } }
  }
  return true
}

private fun FontFace.format(): String {
  return "$family $style, $variant $weight"
}
